import React from 'react';

import UnderConstructionPage from './UnderConstructionPage';

const TermsPage: React.FC = () => <UnderConstructionPage />;

export default TermsPage;
